import React from 'react';
import { cx } from './_cx';

/**
 * Text (UI primitive)
 *
 * Unifies typography sizing and muted text styling.
 */
export function Text({
  as,
  size = 'md', // xs | sm | md | lg | xl
  muted = false,
  weight,
  align,
  style,
  className,
  ...props
}) {
  const Component = as || 'p';
  return (
    <Component
      className={cx(
        'pv-text',
        size && `pv-text--${size}`,
        muted && 'pv-text--muted',
        className
      )}
      style={{
        ...(typeof weight !== 'undefined' ? { fontWeight: weight } : null),
        ...(align ? { textAlign: align } : null),
        ...(style || null),
      }}
      {...props}
    />
  );
}

